/* global attachEvent, clickHandler */

function headerHeight() {
  return document.querySelector('.header-main').offsetHeight;
}

// *******************************************************************************
// Scroll to Section
// *******************************************************************************
attachEvent('.floating-nav__link', 'click', (ev) => {
  const clientRect = document.querySelector(ev.target.hash).getBoundingClientRect();
  const offsetTop = clientRect.top + document.documentElement.scrollTop - headerHeight();
  const parentElem = ev.target.closest('.floating-nav');
  const navLi = parentElem.querySelectorAll('li');

  navLi.forEach((el) => {
    el.classList.remove('is-active');
  });

  ev.target.parentNode.classList.add('is-active');

  clickHandler(offsetTop);
  ev.preventDefault();
});

window.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const id = entry.target.getAttribute('id');
      document.querySelector(`.floating-nav__link[href="#${id}"]`).parentElement.classList.toggle('is-active', entry.intersectionRatio > 0);
    });
  });

  // Track all sections that have an `id` applied
  document.querySelectorAll('section[id]').forEach((section) => {
    observer.observe(section);
  });
});
